import { render, staticRenderFns } from "./PreparedNotificationsTable.vue?vue&type=template&id=42a69446&"
import script from "./PreparedNotificationsTable.vue?vue&type=script&lang=js&"
export * from "./PreparedNotificationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports